<section id="home" class="sc-scroll-bar">
      <div *ngIf="!urlLoaded" class="loading-container">
            <sc-icon icon="loading" size="2"></sc-icon>
      </div>
      <iframe (load)="onLoaded($event)" 
      [ngClass]="{ 'hidden': !urlLoaded, 'showing':urlLoaded }"
      [src]="iframeBodySRC | safe" class="iframeBody" 
      #polizaLogs title="legacy"></iframe>
</section>